import { usePomodoro } from "../features/pomodoro/hooks/use-pomodoro";
import { useTwenty } from "../features/twenty/hooks/use-twenty";
import { useStopwatch } from "../features/stopwatch/hooks/use-stopwatch";

export function useAppTimers(showPomodoro: boolean, showTwenty: boolean, showStopwatch: boolean) {
  const pomodoro = usePomodoro();
  const twenty = useTwenty();
  const stopwatch = useStopwatch();

  const hasTimers = showPomodoro || showTwenty || showStopwatch;
  const anyTimerRunning =
    (showPomodoro && pomodoro.state.isRunning) ||
    (showTwenty && twenty.state.isRunning) ||
    (showStopwatch && stopwatch.state.isRunning);
  const runningTimerCount = [
    showPomodoro && pomodoro.state.isRunning,
    showTwenty && twenty.state.isRunning,
    showStopwatch && stopwatch.state.isRunning,
  ].filter(Boolean).length;

  return { pomodoro, twenty, stopwatch, hasTimers, anyTimerRunning, runningTimerCount };
}
